export default "__VITE_ASSET__4n5nyoOR__"